/**
 * Import from node_modules
 */
import 'bootstrap/js/src/scrollspy';

/**
 * Import site scripts
 */
import SkipLinkFocusFix from './site/skip-link-focus-fix';
import Menu from './site/menu';
import Sliders from './site/sliders';
import ScrollTo from './site/scrollTo';
import Styleguide from './site/styleguide';
import Fancybox from './site/fancybox';
import Select2 from './site/select2';
import FormHelpers from './site/formHelpers';
import PerfectScroll from './site/perfectScroll';
import LazyLoading from './site/lazyLoad';
import LoadMoreBlog from './site/loadMoreBlog';
import equalHeight from './site/equalHeight';
import Popups from './site/popups';
import Counter from './site/counter';
import PageAnchor from './site/pageAnchor';
import Tabs from './site/tab';
import Steps from './site/steps';
import Gsap from './site/gsap';
import Accordion from './site/accordion';
import SliderCircle from './site/circular-slider';
import MemberPopup from './site/member-popup';
import Timeline from './site/timeline';
import GravityForm from './site/gravityForm';
import Teams from './site/teams';
import VerticalSlider from './site/verticalSlider';
import LoadMorePosts from './site/loadMorePosts';
import CheckErrorsPopupForm from './site/checkFormPopup';
import Consumer from './consumers/consumers';
import ProductSearch from './site/product-search';
import ButtonLoader from './site/showLoader';
import PrintPage from './site/printPage';
import hideHoverLine from './site/hideHoverLine';
import scrollToTable from './site/ScrollToTable';
import StoreMap from './site/storeMap';
import RestaurantStoreMap from './site/restaurantMap';
import map from './site/map';
import blogSearch from './site/blog_search';
import ArticleLinks from './site/AddArticleLinks';
import addCalendarButton from './site/AddCalendarLink';
import AlertFormSuccess from './site/AlertForm';
import Subscribe from './site/subscribe';
import SearchTabsSwitcher from './site/searchTabs';
import GlobalSearch from './global-search/GlobalSearch';
import PartnerSlider from './site/partnersSlider';
import ApplicationForm from './site/ApplicationFormScripts';
import RequestQuoteFormScript from './site/request-quote-form-script';
/**
 * Init site scripts
 */
jQuery(function() {
	SkipLinkFocusFix.init();
	Styleguide.init();
	ArticleLinks.init();
	Menu.init();
	Sliders.init();
	ScrollTo.init();
	Fancybox.init();
	Select2.init();
	FormHelpers.init();
	PerfectScroll.init();
	LazyLoading.init();
	LoadMoreBlog.init();
	equalHeight.init();
	Popups.init();
	Counter.init();
	PageAnchor.init();
	Tabs.init();
	Steps.init();
	Gsap.init();
	Accordion.init();
	SliderCircle.init();
	MemberPopup.init();
	Timeline.init();
	GravityForm.init();
	Teams.init();
	VerticalSlider.init();
	LoadMorePosts.init();
	CheckErrorsPopupForm.init();
	Consumer.init();
	ProductSearch.init();
	ButtonLoader.init();
	PrintPage.init();
	hideHoverLine.init();
	scrollToTable.init();
	map.init();
	StoreMap.init();
	RestaurantStoreMap.init();
	blogSearch.init();
	addCalendarButton.init();
	ArticleLinks.init();
	AlertFormSuccess.init();
	Subscribe.init();
	SearchTabsSwitcher.init();
	GlobalSearch.init();
	PartnerSlider.init();
	ApplicationForm.init();
	RequestQuoteFormScript.init();
});
